import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LipSyncDemo from "@/pages/LipSyncDemo";

export function PaolaAssistantWidget() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [isOpen, setIsOpen] = useState(false);
  const { i18n } = useTranslation();
  const isEnglish = i18n.language?.startsWith("en");

  // Auto open via ?chat=paola
  useEffect(() => {
    if (searchParams.get("chat") === "paola") {
      setIsOpen(true);
      searchParams.delete("chat");
      setSearchParams(searchParams, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  return (
    <>
      {!isOpen && (
        <div className="fixed bottom-4 right-4 md:bottom-6 md:right-6 z-[150] flex items-center gap-2">
          <button
            onClick={() => setIsOpen(true)}
            className="hidden sm:flex items-center gap-1.5 bg-primary text-primary-foreground px-3.5 py-2 rounded-full shadow-xl text-sm font-semibold animate-pulse hover:animate-none hover:scale-105 transition-transform"
            aria-label={isEnglish ? "Chat with Paola" : "Parla con Paola"}
          >
            💬 {isEnglish ? "Ask Paola" : "Chiedi a Paola"}
          </button>
          <button
            onClick={() => setIsOpen(true)}
            className="relative h-16 w-16 rounded-full shadow-2xl overflow-hidden ring-4 ring-primary/30 hover:ring-primary/50 transition-all"
            aria-label={isEnglish ? "Chat with Paola" : "Parla con Paola"}
          >
            <span className="absolute inset-0 rounded-full bg-accent/60 animate-ping" />
            <img src="/paola-avatar.jpg" alt="Paola" className="relative w-full h-full object-cover" loading="lazy" />
          </button>
        </div>
      )}

      {isOpen && (
        <div
          className="fixed bottom-4 left-4 right-4 md:bottom-6 md:right-6 md:left-auto md:w-[420px] z-[150] rounded-2xl shadow-2xl overflow-hidden border border-border bg-card"
          style={{ height: "min(720px, calc(100vh - 2rem))" }}
        >
          <LipSyncDemo embedded onClose={() => setIsOpen(false)} />
        </div>
      )}
    </>
  );
}
